import styled from 'styled-components';

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 32px 24px 40px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
`;

export const Greeting = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  color: #1b5c2e;
  margin: 0 0 6px;
  line-height: 1.2;
`;

export const EventLabel = styled.p`
  font-size: 0.75rem;
  font-weight: 600;
  color: #9e9e9e;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 0 0 28px;
`;

export const QRContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  background: #ffffff;
`;

export const InstructionText = styled.p`
  font-size: 1.125rem;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 28px;
  line-height: 1.45;

  @media (min-width: 480px) {
    font-size: 1.25rem;
  }
`;

export const SaveButton = styled.button`
  width: 100%;
  background-color: #4cbb4e;
  color: #ffffff;
  border: none;
  border-radius: 50px;
  padding: 18px 24px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #43a847;
  }

  &:active {
    background-color: #388e3c;
  }

  @media (min-width: 480px) {
    font-size: 1.25rem;
    padding: 20px 24px;
  }
`;

export const ErrorTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 8px;
`;

export const ErrorSubtitle = styled.p`
  font-size: 0.9rem;
  color: #757575;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;

export const FooterText = styled.p`
  font-size: 0.875rem;
  color: #757575;
  text-align: center;
  margin: 0;
  line-height: 1.55;

  @media (min-width: 480px) {
    font-size: 0.9375rem;
  }
`;
